import type { IAnalyticMetricShowing } from '~/modules/analytics/types';
import type { ICampaignAnalyticMapping } from '../types';
import type { IAnalyticMetric } from '~/types/metric';

import { ICampaignMetricKey } from '~/modules/campaign-analytics/types';
import { IVariantType } from '~/modules/campaign/types';

export const DEFAULT_ANALYTIC_DATA_A: IAnalyticMetric = {
  variantKey: IVariantType.VARIANT_A,
  date: '',
  totalSessionsWithCartAdditions: 0,
  totalSessionsThatReachedCheckout: 0,
  totalSessionsThatReachedAndCompletedCheckout: 0,
  totalSessionsThatCompletedCheckout: 0,
  totalSessionsWithoutAction: 0,
  totalClicked: 0,
  totalClickedHasHref: 0,
  totalOrders: 0,
  totalPageViewed: 0,
  totalReachedCheckout: 0,
  totalRevenue: 0,
  totalSessions: 0,
  totalTimeOnPage: 0,
  totalAddedToCart: 0,
  totalPageViewedHaveTimeOnPage: 0,
  totalVisitors: 0,
};
export const DEFAULT_ANALYTIC_DATA_B: IAnalyticMetric = {
  variantKey: IVariantType.VARIANT_B,
  date: '',
  totalSessionsWithCartAdditions: 0,
  totalSessionsThatReachedCheckout: 0,
  totalSessionsThatReachedAndCompletedCheckout: 0,
  totalSessionsThatCompletedCheckout: 0,
  totalSessionsWithoutAction: 0,
  totalClicked: 0,
  totalClickedHasHref: 0,
  totalOrders: 0,
  totalPageViewed: 0,
  totalReachedCheckout: 0,
  totalRevenue: 0,
  totalSessions: 0,
  totalTimeOnPage: 0,
  totalAddedToCart: 0,
  totalPageViewedHaveTimeOnPage: 0,
  totalVisitors: 0,
};

export const CAMPAIGN_ANALYTIC_MAPPING: ICampaignAnalyticMapping[] = [
  {
    metricFuncKey: 'getTotalSessionMetric',
    metricDataKey: 'totalSessionMetric',
    title: 'Total sessions',
    metricKey: ICampaignMetricKey.SESSION,
  },
  {
    metricFuncKey: 'getTotalVisitorMetric',
    metricDataKey: 'totalVisitorMetric',
    title: 'Total visitors',
    metricKey: ICampaignMetricKey.VISITOR,
  },
  {
    metricFuncKey: 'getTotalOrderMetric',
    metricDataKey: 'totalOrderMetric',
    title: 'Total orders',
    metricKey: ICampaignMetricKey.ORDER,
  },
  {
    metricFuncKey: 'getTotalRevenueMetric',
    metricDataKey: 'totalRevenueMetric',
    title: 'Total revenue',
    metricKey: ICampaignMetricKey.REVENUE,
  },
  {
    metricFuncKey: 'getAovMetric',
    metricKey: ICampaignMetricKey.AOV,
    title: 'Average order value',
    metricDataKey: 'aovMetric',
  },
  {
    metricFuncKey: 'getConversionRateMetric',
    metricDataKey: 'conversionRateMetric',
    metricKey: ICampaignMetricKey.CONVERSION_RATE,
    title: 'Conversion rate',
  },
  {
    metricFuncKey: 'getRpvMetric',
    metricDataKey: 'rpvMetric',
    metricKey: ICampaignMetricKey.RPV,
    title: 'Revenue per visitor',
  },
  {
    metricFuncKey: 'getLinkCtrMetric',
    metricDataKey: 'linkCtrMetric',
    metricKey: ICampaignMetricKey.CTR,
    title: 'Click-through rate',
  },
  {
    metricFuncKey: 'getAvgTimeOnPageMetric',
    metricDataKey: 'avgTimeOnPageMetric',
    metricKey: ICampaignMetricKey.AVG_TIME,
    title: 'Average time on page',
  },
  {
    metricFuncKey: 'getTotalViewMetric',
    metricDataKey: 'totalViewMetric',
    metricKey: ICampaignMetricKey.PAGE_VIEWED,
    title: 'Pageviews',
  },
  {
    metricFuncKey: 'getBounceRateMetric',
    metricDataKey: 'bounceRateMetric',
    metricKey: ICampaignMetricKey.BOUNCE_RATE,
    title: 'Bounce rate',
  },
];

export const CAMPAIGN_ANALYTIC_MAPPING_SHOWING: IAnalyticMetricShowing[] = [
  {
    metricKey: ICampaignMetricKey.SESSION,
    position: 0,
  },
  {
    metricKey: ICampaignMetricKey.VISITOR,
    position: 1,
  },
  {
    metricKey: ICampaignMetricKey.ORDER,
    position: 2,
  },
  {
    metricKey: ICampaignMetricKey.REVENUE,
    position: 3,
  },
  {
    metricKey: ICampaignMetricKey.AOV,
    position: 4,
  },
  {
    metricKey: ICampaignMetricKey.CONVERSION_RATE,
    position: 5,
  },
  {
    metricKey: ICampaignMetricKey.RPV,
    position: 6,
  },
];
